import React, { useEffect, useState } from 'react';
import { Container, TextField, Button, Table, TableHead, TableBody, TableCell, TableRow, Pagination, MenuItem, Select, ButtonGroup, CircularProgress, Box } from '@mui/material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

function ProductForDate() {
  const [datosGenerados, setDatosGenerados] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [filtroTexto, setFiltroTexto] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [elementosPorPagina] = useState(50);
  const [comboValue, setComboValue] = useState("");
  const [comboCajaValue, setComboCajaValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [uniqueCajas, setUniqueCajas] = useState([]);

  const fetchData = () => {
    setLoading(true);
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril"
      },
      DatosMetodo: {
        NombreMetodo: "ListaReportesSalas",
        Datos_Recibidos: `{"Vista":"ReporteVentas", "FechaIni":"${fechaInicio}","FechaFin":"${fechaFin}"}`
      }
    }; 

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;

    fetch(fetchDataUrl)
      .then(response => response.json())
      .then(data => {
        try {
          const datosGeneradosLimpiados = data.datos_Generados.replace(/\\\\"/g, '"').replace(/\\\\/g, '\\');
          const datosGeneradosDecodificados = JSON.parse(datosGeneradosLimpiados); 
          setDatosGenerados(datosGeneradosDecodificados);
          
          // Extract unique boxes (Cajas) based on selected store (Sala)
          const cajas = datosGeneradosDecodificados
            .filter(item => !comboValue || item.Sala === comboValue)
            .map(item => item.Caja)
            .filter((value, index, self) => self.indexOf(value) === index && value);
            
          setUniqueCajas(cajas);
          console.log(datosGeneradosDecodificados);
        } catch (error) {
          console.error("Error al decodificar los datos generados:", error);
        }
      })
      .catch(error => console.error('Error:', error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      fetchData();
    }
  }, [fechaInicio, fechaFin, comboValue]);

  const handleSearch = () => {
    if (fechaInicio && fechaFin) {
      fetchData();
    }
  };

  const handlePageChange = (event, value) => {
    setPaginaActual(value);
  };

  const limpiarJSON = (jsonString) => {
    if (!jsonString) return '{"DETALLE":[]}'; // Retorna un JSON vacío si no hay datos
    
    try {
      // Primero intentamos parsear directamente
      JSON.parse(jsonString);
      return jsonString; // Si funciona, retornamos el original
    } catch (e) {
      // Si falla, aplicamos limpieza
      const cleaned = jsonString
        .replace(/\\\\"/g, '"')
        .replace(/\\\\/g, '\\')
        .replace(/\\"/g, '"')
        .replace(/"\s+"/g, '","') // Arregla comillas mal espaciadas
        .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":'); // Asegura comillas en propiedades
      
      try {
        JSON.parse(cleaned);
        return cleaned;
      } catch (e) {
        console.error("No se pudo reparar el JSON:", jsonString);
        return '{"DETALLE":[]}'; // Retorna un JSON vacío si no se puede reparar
      }
    }
  };
  
  const filteredData = datosGenerados.flatMap(item => {
    try {
      // Verificamos si item.Detalle existe y es string
      if (!item.Detalle || typeof item.Detalle !== 'string') {
        return [];
      }
      
      const detalleParseado = JSON.parse(limpiarJSON(item.Detalle));
      const detalle = detalleParseado.DETALLE || [];
      
      return detalle.filter(prod => {
        const searchValue = filtroTexto.toLowerCase();
        const isTiendaValid = comboValue ? item.Sala?.toString() === comboValue : true;
        const isCajaValid = comboCajaValue ? item.Caja?.toString() === comboCajaValue : true;
        
        return (
          (prod?.ItemCode?.toLowerCase().includes(searchValue) || 
           prod?.Dscription?.toLowerCase().includes(searchValue)) &&
          isTiendaValid &&
          isCajaValid
        );
      }).map(prod => {
        const fechaFormateada = item.DocDate?.split('/')?.join('/') || 'Fecha desconocida';
        
        return {
          Caja: item.Caja || '',
          Codigo: prod.ItemCode || '',
          Descripcion: prod.Dscription || '',
          UnidadesVendidas: parseFloat(prod.Cantidad) || 0,
          Costo: parseFloat(prod.Costo) || 0,
          Fecha: fechaFormateada,
          Sala: item.Sala || ''
        };
      });
    } catch (error) {
      console.error("Error al procesar el item:", item, error);
      return [];
    }
  });

  // Agrupar y sumar unidades vendidas por código
  const groupedData = filteredData.reduce((acc, curr) => {
    // Buscar un elemento que coincida tanto en código como en fecha
    const existing = acc.find(item => 
      item.Codigo === curr.Codigo && item.Fecha === curr.Fecha
    );
    
    if (existing) {
      existing.UnidadesVendidas = (parseFloat(existing.UnidadesVendidas) || 0) + (parseFloat(curr.UnidadesVendidas) || 0);
    } else {
      acc.push({ 
        ...curr, 
        UnidadesVendidas: parseFloat(curr.UnidadesVendidas) || 0 
      });
    }
    return acc;
  }, []);

  // Paginación
  const indexUltimoElemento = paginaActual * elementosPorPagina;
  const indexPrimerElemento = indexUltimoElemento - elementosPorPagina;
  const datosPaginados = groupedData.slice(indexPrimerElemento, indexUltimoElemento);

  // Función para generar y descargar PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Configura el encabezado del PDF
    doc.text("REPORTE PRODUCTOS POR FECHA", 20, 10);
  
    // Configura la tabla con autoTable
    doc.autoTable({
      head: [['Caja', 'Código de Producto', 'Descripción', 'Unidades Vendidas', 'Fecha']],
      body: datosPaginados.map(row => [
        row.Caja,
        row.Codigo,
        row.Descripcion,
        row.UnidadesVendidas,
        row.Sala,
        new Date(row.Fecha).toLocaleDateString()
      ]),
    });
  
    // Descarga el PDF
    doc.save('consumo-productos.pdf');
  };

  // Función para exportar a Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(datosPaginados);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReporteProductos");
    XLSX.writeFile(workbook, 'consumo-productos.xlsx');
  };

  return (
    <Container>
      <h1>Consumo por Producto</h1> 
      <hr />
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
        <TextField
          id="filtroTexto"
          label="Buscar"
          value={filtroTexto}
          onChange={(e) => setFiltroTexto(e.target.value)}
          variant="outlined"
          style={{ width: '400px' }}
        />
        
        <div style={{ display: 'flex', gap: '10px' }}>
          <Select
            value={comboValue}
            onChange={(e) => {
              setComboValue(e.target.value);
              setComboCajaValue(""); // Reset box filter when store changes
            }}
            displayEmpty
            style={{ width: '150px' }}
          >
            <MenuItem value="">Todas las Tiendas</MenuItem>
            <MenuItem value={"TZ10"}>TZ10</MenuItem>
            <MenuItem value={"TPRR"}>TPRR</MenuItem>
            <MenuItem value={"TSCR"}>TSCR</MenuItem>
            <MenuItem value={"TCSV"}>TCSV</MenuItem>
            <MenuItem value={"TMIR"}>TMIR</MenuItem>
            <MenuItem value={"TXLA"}>TXLA</MenuItem>
          </Select>

          <Select
            value={comboCajaValue}
            onChange={(e) => setComboCajaValue(e.target.value)}
            displayEmpty
            style={{ width: '150px' }}
            disabled={!comboValue}
          >
            <MenuItem value="">Todas las Cajas</MenuItem>
            {uniqueCajas.map((caja, index) => (
              <MenuItem key={index} value={caja}>{caja}</MenuItem>
            ))}
          </Select>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <TextField
            id="fechaInicio"
            label="Fecha de Inicio"
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
          <TextField
            id="fechaFin"
            label="Fecha de Fin"
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
        </div>

        <ButtonGroup>
          <Button 
            variant="contained" 
            onClick={handleSearch} 
            style={{ height: '55px', width: '100px' }}
            disabled={!fechaInicio || !fechaFin}
          >
            Buscar
          </Button> 

          <Button 
            variant="contained" 
            onClick={exportToPDF} 
            style={{ marginRight: '4px', marginLeft: '4px' }} 
            color='warning'
            disabled={groupedData.length === 0}
          >
            PDF
          </Button>
          <Button 
            variant="contained" 
            onClick={exportToExcel} 
            color='success'
            disabled={groupedData.length === 0}
          >
            Excel
          </Button> 
        </ButtonGroup>
      </div>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="200px">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Caja</TableCell>
                <TableCell>Código de Producto</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Unidades Vendidas</TableCell>
                <TableCell>Fecha</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {datosPaginados.length > 0 ? (
                datosPaginados.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.Caja}</TableCell>
                    <TableCell>{item.Codigo}</TableCell>
                    <TableCell>{item.Descripcion}</TableCell>
                    <TableCell>{item.UnidadesVendidas}</TableCell>
                    <TableCell>{item.Fecha}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No hay datos disponibles
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {groupedData.length > 0 && (
            <Pagination
              count={Math.ceil(groupedData.length / elementosPorPagina)}
              page={paginaActual}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              style={{ marginTop: '20px' }}
            />
          )}
        </>
      )}
    </Container>
  );
}

export default ProductForDate;